import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakeGetResponder, createFakePostResponder, isWildcard, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createLinesApi } from './';
export var createLinesApiTestKit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createLinesApi(parent, fakeHttp);
    var testKit = {
        whenGetLinesByIVR: function (ivrDto) {
            return createFakeGetResponder(fakeHttp, "".concat(parent, "/lines/ivr?ivrId=").concat(ivrDto === '*' ? '' : ivrDto.id));
        },
        whenGetLines: function () {
            return createFakeGetResponder(fakeHttp, "".concat(parent, "/lines"));
        },
        whenGetLineById: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId));
        },
        whenFindAvailablePhoneNumbers: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(parent, "/lines/availablePhoneNumbers/").concat(isWildcard(dto) ? 'US' : dto.countryCode, "?tollFree=").concat(isWildcard(dto) ? 'true' : dto.tollFree));
        },
        whenUpdateLineDetails: function (dto) {
            var payload = dto === '*' ? {} : { name: dto.name, description: dto.description };
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId))(payload);
        },
        whenAddLine: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(parent, "/lines/"))(dto);
        },
        whenDeleteLine: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId));
        },
        whenGetSchedule: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule"));
        },
        whenSetScheduleBusinessHours: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule/businesshours"))(dto);
        },
        whenSetScheduleOpeningHours: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule/openingHours"))(dto);
        },
        whenSetScheduleDownTimes: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule/downtimes"))(dto);
        },
        whenSetOffHoursVoiceMessage: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule/businesshours/offHours/message/voice"))(dto);
        },
        whenSetOffHoursSmsMessage: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule/offHours/message/text"))(dto);
        },
        whenSetInbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled, ivrId: dto.ivrId };
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/inbound"))(payload);
        },
        whenSetOutbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled };
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/outbound"))(payload);
        },
        whenSetSmsInbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled };
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/sms/inbound"))(payload);
        },
        whenSetSmsOutbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled };
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/sms/outbound"))(payload);
        },
        whenSetDefault: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/setDefault"))({});
        },
        whenSetSmsDefault: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/sms/setDefault"))({});
        },
        whenSetInboundInactiveVoiceMessage: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/inactiveLineVoiceMessage"))(dto);
        },
        whenGetLinesStatus: function () {
            return createFakeGetResponder(fakeHttp, "".concat(parent, "/lines/status"));
        },
        whenSetLinesStatus: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/status"))(dto);
        },
        whenSetScheduleId: function (dto) { return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/").concat(dto === '*' ? '' : dto.lineId, "/schedule"))(dto); },
        whenSetAllLinesScheduleId: function (dto) { return createFakePutResponder(fakeHttp, "".concat(parent, "/lines/schedule/all"))(dto); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map